import iconThriveHandshake from "@assets/thrive_images/icon-thrive-handshake.png";

/**
 * Component to render success message after signing up for Thrive newsletter
 * https://www.figma.com/design/UWKZEzXYf0Gf5e6sfqsKVC/THRIVE-WORKING-FILE?node-id=8869-88058&m=dev
 */
const ThriveSuccessMessage = () => {
  return (
    <div
      className="inline-flex rotate-[-2deg] flex-row items-center bg-yellow-100 p-1"
      data-testid="thrive-success-message"
    >
      <img
        src={iconThriveHandshake}
        alt="thrive-handshake"
        width={50}
        height={50}
      />

      <p className="font-inter text-base text-green-600">
        Thank you! You&apos;re now signed up.
      </p>
    </div>
  );
};

export default ThriveSuccessMessage;
